import handleResponse from "@/assets/handle-response";
import wretch from "wretch";

export default ({ state, commit, dispatch }, host) => {
  host, dispatch;
  return wretch("/api/create-host")
    .auth(state.email)
    .formData(host)
    .post()
    .json()
    .then(handleResponse)
    .then(() => {
      dispatch("getHosts");
    })
    .catch(text => {
      commit("setSnack", {
        visible: true,
        color: "error",
        text
      });
    });
};
